export default "__VITE_ASSET__BQPkhWY0__"